import {tokenAuth, serviceRefreshToken} from "./serviceToken";

export async function passwordReset(url: RequestInfo, token: string, hash: string, password: string, repeatPassword: string) {

    await tokenAuth(url);

    return await fetch(url + '/api/password-reset', {
        method: 'POST',
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem('@Unisuam/authToken'),
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(
            {
                'token': token,
                'hash': hash,
                'password': password,
                'repeat_password': repeatPassword,
            }
        )
    })
        .then(response => {

            if (response.status === 401) {
                serviceRefreshToken(url);
            }

            return response.json();
        })
        .catch(err => {
            console.log(err);
        });
}